module.exports = __webpack_public_path__ + "img/logo-full.80027cef.svg";